<template>
    <van-popup v-model:show="show" position="bottom" :overlay-style="{ overflow: 'hidden' }" :style="{
        minWidth: '100%',
        minHeight: '100%',
        color: '#fff',
        zIndex: '1998'
    }">
        <div class="agent_container">
            <CustomHeader text="Agente" :isPopupCloseBackIcon="true" @closePopup="close" />
            <div class="container">
                <img :src="dataSet.bannerImage" alt="">
                <van-tabs v-model:active="active" sticky :ellipsis="false" @click-tab="onClickTab">
                    <van-tab v-for="(item, index) in tabList" :key="index" :title="$t(item.name)" :name="index">
                    </van-tab>
                </van-tabs>

            </div>
            <InvitationView v-if="dataSet.activeTab == 0" @closePoup="close" />
            <MyDataView v-if="dataSet.activeTab == 1" />
            <CommissionView v-if="dataSet.activeTab == 2" />
            <DetailsView v-if="dataSet.activeTab == 3" />
            <FaqView v-if="dataSet.activeTab == 4" />
        </div>

    </van-popup>

</template>

<script setup lang="ts">
import CustomHeader from '@/themes/themeTwo/components/common/customHeader.vue';
import { ref, defineExpose, computed, defineEmits, defineProps, watch } from 'vue'
import InvitationView from './components/invitationView.vue';
import MyDataView from './components/myDataView.vue';
import CommissionView from './components/commissionView.vue';
import DetailsView from './components/detailsView.vue';
import FaqView from './components/faqView.vue';
import { useI18n } from 'vue-i18n';
import { useActivityStore } from '@/stores/activity';
import { AgentData, TAB_LIST } from '@/view/agent/supportScript';

const { t } = useI18n();
const show = ref(false)

const tabList = ref(TAB_LIST)
const activeTab = ref(0)
const emit = defineEmits(['onClickTab', 'close', 'update:show'])

const props = defineProps<{
    dataSet: AgentData
}>()

const active = ref(props.dataSet.activeTab)

watch(() => props.dataSet.activeTab, (val) => {
    active.value = val
})

watch(active, (val) => {
    emit('update:show', val)
})

const close = () => {
    emit('close')
}
const onClickTab = (value: any) => {
    console.log('value>>',value);
    emit('onClickTab', value)
}

</script>
<style scoped>
.van-popup {
    background: #221b24;
    background-size: cover;
    background-repeat: repeat;
    -ms-overflow-style: none;
    scrollbar-width: none;
    overflow-y: auto;
    width: 100%;
    min-height: 100vh;
    padding: 50px 0;
}

.van-overlay {
    z-index: 1997 !important;
}

.agent_container::-webkit-scrollbar {
    display: none;
}

.scrollable-content {
    /* flex: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch; */
}

.van-popup::-webkit-scrollbar {
    display: none;
}

.container {
    width: 100%;
    padding-top: 30px;
}

.container img {
    width: 100%;
}

.container>>>.van-tabs__wrap {
    background: #00000080;
    backdrop-filter: blur(10px);
    margin-top: -40px;
    /* border-bottom: 1.5px solid #00000080; */
    height: 37px;
}

.container>>>.van-tabs__nav {
    background: #00000080;
    padding: 0 15px;
}

.container>>>.van-tab {
    color: rgba(255, 255, 255, 0.85);
    font-weight: 700;
    border-radius: 10px 10px 0 0;
    font-size: 13px;
    margin: 0 3px;
    padding: 0 10px;
}

.container>>>.van-tab.van-tab--active {
    color: #fff;
    background-image: linear-gradient(180deg, #ff3d9e, #fd66b1);
    font-weight: 700;
}

.container>>>.van-tabs__line {
    background-color: transparent;
    height: 0px;
}


:deep(.van-tabs__wrap),
:deep(.van-tabs__scroll),
:deep(.van-tabs__nav),
:deep(.van-tabs__nav--line),
:deep(.van-tab) {
    scrollbar-width: none !important;  /* Firefox */
}

:deep(.van-tabs__wrap::-webkit-scrollbar),
:deep(.van-tabs__scroll::-webkit-scrollbar),
:deep(.van-tabs__nav::-webkit-scrollbar),
:deep(.van-tabs__nav--line::-webkit-scrollbar),
:deep(.van-tab::-webkit-scrollbar) {
    display: none !important;   /* Chrome, Safari, Edge */
}
</style>